//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
let d=[[[0,"AgeInput",1,0],[0,"AnkleHeight",1,0],[0,"ArmLengthInput",1,0],[0,"ArmLengthInputTyp",1,0],[0,"AssociateCheck",1,0],[0,"AssociatePoint",1,"Point",0],[0,"ChestCircumference",1,0],[0,"Database",1,0],[0,"ElbowFingertipLength",1,0],[0,"ElbowWristLength",1,0],[0,"FootBreadth",1,0],[0,"FootLength",1,0],[0,"FunctionalLegLength",1,0],[0,"Gender",1,0],[0,"HandBreadth",1,0],[0,"HandDepth",1,0],[0,"HandLength",1,0],[0,"HeadBreadth",1,0],[0,"HeadHeight",1,0],[0,"HeadLength",1,0],[0,"HeightPercentile",1,0],[0,"HeightUnits",1,0],[0,"HeightValue",1,0],[0,"HipBreadthInput",1,0],[0,"HipBreadthInputTyp",1,0],[0,"LegLengthInput",1,0],[0,"LegLengthInputTyp",1,0],[0,"Name",1,0],[0,"RefPoint",1,0],[0,"ShoeSoleHeight",1,0],[0,"ShoulderBreadthInput",1,0],[0,"ShoulderBreadthInputTyp",1,0],[0,"ShoulderElbowLength",1,0],[0,"SittingHeight",1,0],[0,"TorsoHeightInput",1,0],[0,"TorsoHeightInputTyp",1,0],[0,"UseArmLength",1,0],[0,"UseElbowFingertipLength",1,0],[0,"UseElbowWristLength",1,0],[0,"UseFunctionalLegLength",1,0],[0,"UseHandLength",1,0],[0,"UseShoulderElbowLength",1,0],[0,"UseSittingHeight",1,0],[0,"UseTorsoHeightInput",1,0],[0,"WaistCircumference",1,0],[0,"WeightPercentile",1,0],[0,"WeightUnits",1,0],[0,"WeightValue",1,0]],[[["humanfeaturebuilder"],"SetHumanFeatureBuilder",{},1,0]],[]];
SPLM.HumanH10DialogBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.HumanH10DialogBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.HumanH10DialogBuilder.GenderType = Object.freeze({
    "Male" : "Male", "Female" : "Female"});

SPLM.HumanH10DialogBuilder.DatabaseType = Object.freeze({
    "Ansur" : "Ansur", "Ansur2" : "Ansur2", "Nhanes" : "Nhanes", "Nhanes2014" : "Nhanes2014"});

SPLM.HumanH10DialogBuilder.HeightUnitsEnum = Object.freeze({
    "In" : "In"});

SPLM.HumanH10DialogBuilder.HeightInputType = Object.freeze({
    "Custom" : "Custom", "Predictfromweight" : "Predictfromweight"});

SPLM.HumanH10DialogBuilder.WeightUnitsEnum = Object.freeze({
    "Kg" : "Kg", "Lbs" : "Lbs"});

SPLM.HumanH10DialogBuilder.WeightInputType = Object.freeze({
    "Custom" : "Custom", "Predictfromheight" : "Predictfromheight"});

SPLM.HumanH10DialogBuilder.ShoulderBreadthInputType = Object.freeze({
    "BiacromialBreadth" : "BiacromialBreadth", "BideltoidBreadth" : "BideltoidBreadth"});

SPLM.HumanH10DialogBuilder.HipBreadthInputType = Object.freeze({
    "HipBreadth" : "HipBreadth", "HipCircumference" : "HipCircumference"});

SPLM.HumanH10DialogBuilder.TorsoHeightInputType = Object.freeze({
    "SeatedAcromion" : "SeatedAcromion", "SeatedEye" : "SeatedEye", "SittingHeight" : "SittingHeight", "StandingAcromion" : "StandingAcromion"});

SPLM.HumanH10DialogBuilder.ArmLengthInputType = Object.freeze({
    "ArmLength" : "ArmLength", "ThumbtipReach" : "ThumbtipReach"});

SPLM.HumanH10DialogBuilder.LegLengthInputType = Object.freeze({
    "KneeHeight" : "KneeHeight", "ButtockKneeLength" : "ButtockKneeLength"});

SPLM.HumanH10DialogBuilder.RefPointType = Object.freeze({
    "Leftfoot" : "Leftfoot", "Rightfoot" : "Rightfoot"});

export default SPLM;